import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useObras } from "@/features/stages/hooks/use-obras.ts";
import { obraSwitchPath, resolveObra } from "@/features/stages/obra.ts";
import { useActiveContext } from "@/store/use-active-context.ts";

export function useContextSync() {
	const { data: obras } = useObras();
	const { obra: urlValue } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const activeObraId = useActiveContext((state) => state.activeObraId);
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);
	const setActive = useActiveContext((state) => state.setActive);

	useEffect(() => {
		if (!obras || obras.length === 0) return;

		const fromUrl = resolveObra(obras, urlValue);
		if (fromUrl) {
			if (
				fromUrl.id !== activeObraId ||
				fromUrl.canteiroId !== activeCanteiroId
			) {
				setActive(fromUrl.canteiroId, fromUrl.id);
			}
			return;
		}

		const fromStore = obras.find((o) => o.id === activeObraId);
		const target = fromStore ?? obras[0];
		if (!target) return;
		navigate(obraSwitchPath(target, location), { replace: true });
	}, [
		obras,
		urlValue,
		activeObraId,
		activeCanteiroId,
		setActive,
		navigate,
		location,
	]);
}
